import * as React from 'react';
import DefaultSubmissionFormProgressProps from 'Feature/DefaultSubmissionForm/models/DefaultSubmissionFormProgressProps';

const DefaultSubmissionFormProgress = (props: DefaultSubmissionFormProgressProps) => <div></div>;

export default DefaultSubmissionFormProgress;
